<template>
  <md-list class="md-layout md-alignment-space-around-space-between">
    <div>
      <router-link :to="{name: 'BackendAdminBillings'}">
        <div class="md-alignment-center">
          <img src="https://cdn.jon-api.com/shikaku-map/img/logo-s.png">
        </div>
      </router-link>
      <div class="md-layout md-alignment-center mb-10">
        <span class="md-caption">シカクマップ請求管理</span>
      </div>
      <md-divider></md-divider>
      <router-link tag="md-list-item" :to="{name: 'BackendAdminBillings'}"
                   :class="activeRouteClass(['BackendAdminBillings', 'BackendAdminBillingDetail'])">
        <md-icon>payment</md-icon>
        <span class="md-list-item-text">請求管理</span>
      </router-link>
      <router-link tag="md-list-item" :to="{name: 'BackendAdminLogs'}">
        <md-icon>history</md-icon>
        <span class="md-list-item-text">ログ管理</span>
      </router-link>
      <router-link tag="md-list-item" :to="{name: 'BackendAdminNotifications'}"
                   :class="activeRouteClass(['BackendAdminNotifications', 'BackendAdminNotificationNew'])">
        <md-icon>notification_important</md-icon>
        <span class="md-list-item-text">お知らせ管理</span>
      </router-link>
      <router-link tag="md-list-item" :to="{name: 'BackendAdminFaqs'}"
                   :class="activeRouteClass(['BackendAdminFaqs', 'BackendAdminFaqNew'])">
        <md-icon>question_answer</md-icon>
        <span class="md-list-item-text">お問い合わせ・FAQ</span>
      </router-link>
    </div>
    <div>
      <router-link tag="md-list-item" :to="{name: 'BackendAdmins'}"
                   :class="activeRouteClass(['BackendAdmins', 'BackendAdminNew'])">
        <md-icon>playlist_play</md-icon>
        <span class="md-list-item-text">システム管理者管理</span>
      </router-link>
      <router-link tag="md-list-item" :to="'#'" @click.native="logOutAdmin">
        <md-icon>logout</md-icon>
        <span class="md-list-item-text">ログアウト</span>
      </router-link>
    </div>
  </md-list>
</template>

<script>
  import CommonMixin from "../../../mixins/commonMixin";

  export default {
    name  : "AdminSidebar",
    mixins: [CommonMixin],
  }
</script>

<style lang="scss" scoped>
  .mb-10 {
    margin-bottom: 10px;
  }
</style>
